import { type ErrorRouteComponent, useRouter } from "@tanstack/react-router";
import { Suspense } from "react";
import { Modal } from "#/_packages/umbrella/components/ui/primitives/modal.tsx";
import { createRendererModule } from "#/_packages/umbrella/integrations/umbraco/utils/renderer-module";
import NotFoundComponent from "#/_packages/umbrella/lib/tanstack-router/components/NotFoundComponent.tsx";
import DefaultError from "./default-error";

const LoginDialogForm = createRendererModule(async () => {
	const module = await import(
		"#/_packages/umbrella/features/authentication/components/login-form.tsx"
	);
	return { default: module.LoginDialogForm };
}).Renderer;

const RouteError: ErrorRouteComponent = ({ error, reset }) => {
	const router = useRouter({ warn: false });
	const retry = () => (router ? router.invalidate() : reset());
	const status =
		typeof error === "object" &&
		error !== null &&
		"type" in error &&
		error.type === "http-error" &&
		"status" in error
			? error.status
			: undefined;
	if (status === 401)
		return (
			<Modal isOpen>
				<Suspense fallback={null}>
					<LoginDialogForm onSignIn={retry} />
				</Suspense>
			</Modal>
		);
	if (status === 404) return <NotFoundComponent />;
	return (
		<DefaultError error={error} message={error?.message} onRetry={retry} />
	);
};
export default RouteError;
